import { getAuth } from "firebase/auth";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const INVESTOR_METRICS_ENDPOINT = `${API_BASE_URL}/investor-metrics`;

/**
 * Fetch investor metrics (NOI, DSCR, debtService) from the backend.
 * Used by Dashboard Portfolio Health. Falls back to local NOI if endpoint is unavailable.
 * @returns {Promise<{ noi?: number, dscr?: number, debtService?: number } | null>}
 */
export async function getInvestorMetrics() {
  try {
    const user = getAuth().currentUser;
    const token = user ? await user.getIdToken() : null;
    const res = await fetch(INVESTOR_METRICS_ENDPOINT, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    });
    if (!res.ok) {
      if (res.status === 404 || res.status === 501) return null;
      throw new Error(`investor-metrics ${res.status}`);
    }
    const data = await res.json();
    const raw = data?.data ?? data;
    return {
      noi: typeof raw.noi === "number" ? raw.noi : undefined,
      dscr: typeof raw.dscr === "number" ? raw.dscr : undefined,
      debtService:
        typeof raw.debtService === "number" ? raw.debtService : undefined,
    };
  } catch (err) {
    console.debug(
      "[investorMetricsApi] getInvestorMetrics failed:",
      err?.message || err
    );
    return null;
  }
}
